module.exports = __webpack_public_path__ + "img/front.d343feff.jpg";